import BlockTitle from "../blockTitle";
import Button from "../../../../../../publicComponent/Button";
import CouponCard from "../../../../components/CouponCard";
import {useProduceCoupon, useQueryCouponReceive} from "../../../../../../api/couponReceive";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import {HomeController} from "../../../../../../reducer/moduleReducer/home";

function CouponBotton({item,recevierCoupon,t}){
  
  return  (
    item.sendTotalQty > item.takenTotalQty
      ? <Button onClick={() => recevierCoupon(item)}
                className="px-[15px] py-[3px] bg-[#eece7a] rounded-[99px] text-[14px]">
        {item.type === '0' ? t('领取') : t('兑换')}
      </Button>
      : <Button className="px-[15px] py-[3px] bg-[#ddd] rounded-[99px] text-[14px]">
        {t('已领完')}
      </Button>
  )
}

export default function Coupon() {
  const { recevierCoupon } = HomeController();
  const [query] = useState({
    page: 1,
    limit: 9,
  });
  const { t } = useTranslation();
  const { result } = useQueryCouponReceive(query);
  const { data } = result;
  
  return (
    <div className="container-center mobile text-[0px] md:pb-[90px]">
      <BlockTitle title={t('优惠券')}/>
      {
        data &&
        <div className="grid grid-cols-3 mdmax:grid-cols-1 lg:gap-10 md:gap-4 mdmax:gap-4">
          {
            data.records.map((item, i) => (
              <CouponCard
                key={i}
                data={item}
                button={<CouponBotton t={t} item={item} recevierCoupon={recevierCoupon}/>}/>
            ))
          }
        </div>
      }
    </div>
  );
}
